/**
 * 基于useTimer.ts 改写的倒计时执行器 请尽量使用这个函数
 * @param options 配置项
 * @returns {
 *   start: () => void,
 *   destroyTimer: () => void,
 *   time: Ref<number>,
 *   state: Ref<'start' | 'end'>
 * }
 */
import { ref, onUnmounted } from 'vue';

interface CountdownOptions {
  // default: 60000
  duration?: number;
  action?: () => Promise<any> | void;
  step?: number;
  loop?: boolean;
  immediate?: boolean;
}

export default function useCountdown(options: CountdownOptions) {
  // 初始化参数
  const { duration = 60*1000, action, step = 1000, loop = false, immediate = false } = options;

  // 内部状态
  const timeLeft = ref<number>(duration);
  const state = ref<'idle' | 'running' | 'completed'>('idle');

  let timer: ReturnType<typeof setTimeout> | null = null;

  // 创建倒计时
  
  const countdown = () => {
    if (timer) clearTimeout(timer);

    if (timeLeft.value <= 0) {
      handleCompletion();
      return;
    }

    timer = setTimeout(() => {
      timeLeft.value -= step;
      countdown();
    }, step);
  };

  // 处理倒计时结束
  const handleCompletion = async () => {
    state.value = 'completed';

    if (action) await action();

    if (loop) {
      reset();
      countdown();
    } else {
      stop();
    }
  };

  // 启动倒计时
  const start = () => {
    if (state.value === 'running') return; // 防止重复启动

    state.value = 'running';
    timeLeft.value = duration;

    if (immediate && action) {
      action();
    }
    countdown();
  };
  // 停止倒计时
  const stop = () => {
    state.value = 'idle';
    if (timer) clearTimeout(timer);
  };

  // 重置倒计时
  const reset = () => {
    stop();
    timeLeft.value = duration;
  };

  // 页面卸载时清除定时器
  onUnmounted(() => {
    if (timer) clearTimeout(timer);
  });
  return {
    countdown: timeLeft,
    start,
    stop,
    reset,
  };
}
